// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"65":"comparison-bulk","348":"comparison"}[chunkId] + "." + {"65":"9a8b29c0","348":"751cd1f8"}[chunkId] + ".chunk.css";
};